export default {
    "name": "StoresForLogin",
    "kind": "HoudiniQuery",
    "hash": "5d4bc05eddb2a7cc86c7b09642432b184d1829d9bf2e7ea8b0e1347f3536e196",

    "raw": `query StoresForLogin {
  storesForLogin {
    id
    code
    name
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "storesForLogin": {
                "type": "RestrictedStore",
                "keyRaw": "storesForLogin",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "code": {
                            "type": "String",
                            "keyRaw": "code",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=b4b46f84981b9a1784fbd6defbf5b23ae37673ec1edd1c40d3fc10cc29d8ba26";